import domain from "./domain";

// Reset workspace
export const resetWorkspace = domain.createEvent('resetWorkspace');
